import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MessageSquare, ArrowLeft } from "lucide-react";

const PHONE = "+91 81053 83975";
const EMAIL = "help@spora1.com";

export default function Help() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="glass sticky top-0 z-50 border-b border-border">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6">
          <Link to="/" data-testid="help-logo" className="flex items-center">
            <img src="/spora1-logo.webp" alt="SPORA1" className="h-9 w-auto sm:h-10" />
          </Link>
          <div className="flex items-center gap-3">
            <Link to="/login" className="text-sm font-semibold text-muted-foreground hover:text-foreground">Sign in</Link>
            <Link to="/register" className="rounded-full bg-primary px-5 py-2 text-sm font-semibold text-primary-foreground hover:bg-[#FF8533]">Get started</Link>
          </div>
        </div>
      </header>

      <div className="mx-auto max-w-2xl px-4 py-14 sm:px-6">
        <Link to="/" className="mb-6 inline-flex items-center gap-1.5 text-sm font-medium text-muted-foreground hover:text-foreground">
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>
        <h1 className="font-display text-4xl font-bold tracking-tight sm:text-5xl">Help & Support</h1>
        <p className="mt-3 text-base text-muted-foreground">
          Questions about bookings, events, teams or your account? The SPORA1 team is here to help.
        </p>

        <div className="mt-8 space-y-4">
          <a href={`tel:${PHONE.replace(/ /g, "")}`} data-testid="help-call"
            className="flex items-center gap-4 rounded-2xl border border-border bg-card p-5 transition-all hover:-translate-y-0.5 hover:border-primary/50 hover:shadow-lg">
            <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary"><Phone className="h-5 w-5" /></span>
            <div>
              <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Call us</p>
              <p className="font-display text-lg font-bold">{PHONE}</p>
            </div>
          </a>

          <a href={`mailto:${EMAIL}`} data-testid="help-email"
            className="flex items-center gap-4 rounded-2xl border border-border bg-card p-5 transition-all hover:-translate-y-0.5 hover:border-primary/50 hover:shadow-lg">
            <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary"><Mail className="h-5 w-5" /></span>
            <div>
              <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Email us</p>
              <p className="font-display text-lg font-bold">{EMAIL}</p>
            </div>
          </a>

          <div className="rounded-2xl border border-border bg-card p-5">
            <div className="flex items-center gap-3">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-50 text-emerald-600"><MessageSquare className="h-5 w-5" /></span>
              <div>
                <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Community</p>
                <p className="font-display text-lg font-bold">Ask the community</p>
              </div>
            </div>
            <p className="mt-3 text-sm text-muted-foreground">Post your question in the SPORA1 community and get answers from players, coaches and organizers.</p>
            <Link to="/login?redirect=%2Fapp%2Fcommunity" data-testid="help-community"
              className="mt-4 inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2.5 text-sm font-semibold text-primary-foreground hover:bg-[#FF8533]">
              Go to community
            </Link>
          </div>
        </div>

        <p className="mt-10 text-center font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground">
          One Ecosystem • One Technology • Many Champions
        </p>
      </div>
    </div>
  );
}
